import React from "react";
import { t } from "i18next";
import {
  Layout,
  Typography,
  Row,
  Col,
  Card,
  Divider,
  Image,
  Carousel,
  Breadcrumb,
} from "antd";
import { NavLink } from "react-router-dom";
import { ArrowLeftOutlined } from "@ant-design/icons";
import img from "../../assets/13.jpg";
import img1 from "../../assets/ab-1.png";
import img2 from "../../assets/ab-2.png";
import img3 from "../../assets/ab-3.png";

import s from "./styles.module.css";
import { Fade } from "react-awesome-reveal";
import { SendButton } from "../../components/SendButton";

const { Header, Content } = Layout;
const { Title, Paragraph } = Typography;

export const AboutUs = () => {
  return (
    <Layout>
      <Row
        style={{
          position: "absolute",
          maxWidth: "1440px",
          top: "80px",
          margin: "0 auto",
          padding: "0 20px",
          zIndex: 100,
          right: 0,
          left: 0,
        }}
      >
        <Col>
          <Title className={s["about-us-title"]}>Our Team</Title>
          <Breadcrumb
            items={[
              {
                title: (
                  <NavLink to={"/"}>
                    <ArrowLeftOutlined style={{ marginRight: "5px" }} />
                    Back to main
                  </NavLink>
                ),
              },
            ]}
          />
        </Col>
      </Row>
      <Carousel effect={"fade"}>
        <div className={s["main-carusel-wrapper"]}>
          <img src={img} alt="Executive" className="responsive-image" />
          <Content
            style={{ padding: "24px", maxWidth: "1440px", margin: "0 auto" }}
          >
            <Row className={s["main-carusel-row"]}>
              <Col xs={24} md={12} style={{ zIndex: 2 }}>
                <div className={s["main-carusel-title"]}>
                  Crafting ‘Reward Strategies’ for Tomorrow’s Leaders
                </div>
                <Paragraph className={s["main-carusel-description"]}>
                  We are more than just consultants—we are your strategic
                  partners in shaping the future of leadership and governance.
                  Specializing in Executive Compensation, Board of Directors
                  Pay, and ESG (Environmental, Social, and Governance) services,
                  we work alongside top-tier organizations to develop
                  cutting-edge solutions that attract, retain, and motivate the
                  leaders of tomorrow.
                </Paragraph>
              </Col>
            </Row>
          </Content>
        </div>
      </Carousel>
      <Divider />
      <Content
        style={{ padding: "24px", maxWidth: "1440px", margin: "0 auto" }}
      >
        <Fade cascade triggerOnce damping={0.1}>
          <Row gutter={[16, 16]}>
            <Col xs={24} md={12}>
              <Card className={s["about-us-card"]}>
                <Image src={img1} preview={false} />
                <Title level={3}>
                  Empowering Leadership through Tailored Compensation Strategies
                </Title>
                <Paragraph>
                  With decades of experience in executive compensation, we
                  understand that today’s leaders require more than just
                  competitive pay — they need compensation packages that reflect
                  the evolving business landscape and align with corporate
                  objectives. We design custom strategies that balance
                  short-term incentives with long-term growth, ensuring your
                  leadership team is always motivated to drive innovation and
                  success.
                </Paragraph>
              </Card>
            </Col>
            <Col xs={24} md={12}>
              <Card className={s["about-us-card"]}>
                <Image src={img2} preview={false} />

                <Title level={3}>
                  Board of Directors Pay: Building Governance with Purpose
                </Title>
                <Paragraph>
                  The role of boards is more critical than ever in guiding
                  companies through complex regulatory environments and
                  stakeholder expectations. We provide expert insights and
                  benchmarking to structure board compensation that aligns with
                  your company’s values and promotes effective governance. We
                  aim to ensure board members receive the correct compensation
                  and equipment to lead purposefully.
                </Paragraph>
              </Card>
            </Col>
          </Row>
          <Divider />
          <Row>
            <Col xs={24}>
              <Card className={s["about-us-card"]}>
                <Image src={img3} preview={false} />

                <Title level={3}>
                  Driving Sustainable Success through ESG Services
                </Title>
                <Paragraph>
                  Sustainability and social responsibility are no longer
                  optional but essential to a successful business strategy. Our
                  ESG services help organizations integrate environmental,
                  social, and governance criteria into their decision-making
                  processes. We guide you in aligning leadership goals with ESG
                  principles, ensuring your company meets stakeholder
                  expectations while driving long-term value.
                </Paragraph>
              </Card>
            </Col>
          </Row>
          <Divider />
          <Row justify="center" className={s["about-us-footer"]}>
            <Col xs={24}>
              <Paragraph>
                We help you navigate today’s challenges while building the
                frameworks for future success. Let’s shape the future of
                leadership together.
              </Paragraph>
              <SendButton
                type="primary"
                size="large"
                className={s["about-us-button"]}
              >
                Get in Touch
              </SendButton>
            </Col>
          </Row>
        </Fade>
      </Content>
    </Layout>
  );
};
